export default "__VITE_ASSET__D___mq9h__"